import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import HistoryAlarmContainer from './HistoryAlarmContainer';
import Messages from './Messages';
import s from './HistoryAlarms.css';
import { getPayloadId } from '../../core/deviceHelper';


class HistoryAlarm extends React.Component {
  onClick = (url, event) => {
    if (!event.target.rel || (event.target.rel && (event.target.rel !== 'userLink'))) {
      Location.push(url);
    }
  };

  render() {
    const alert = this.props.alert;
    const alertType = alert.get('alert_type');
    const payload = getPayloadId(alert.get('payload'), alertType);
    const messages = Messages();
    const alertContainerProps = {
      created: this.props.small ? null : alert.get('created'),
      message: messages[payload],
    };
    // const currentLocation = Location.getCurrentLocation().pathname;
    const devicePhoto = '';

    switch (alertType) {
      case 'softener-device-notification':
      case 'softener-device-alarm':
      case 'superior-device-notification':
      case 'superior-device-alarm':
      case 'simplex-device-notification':
      case 'simplex-device-alarm':
        return <HistoryAlarmContainer {...alertContainerProps} />;
      case 'safet-device-alarm':
      case 'safetech-device-alarm':
        return <HistoryAlarmContainer {...alertContainerProps} />;
      default:
        return (
          <HistoryAlarmContainer {...alertContainerProps}>
            Unknown type ({alertType}) of alert!
          </HistoryAlarmContainer>
        );
    }
  }
}

HistoryAlarm.propTypes = {
  alert: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types 
  small: PropTypes.bool,
  user: PropTypes.object,
};

export default withStyles(s)(HistoryAlarm);



// WEBPACK FOOTER //
// ./src/components/HistoryAlarms/HistoryAlarm.js